(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["selouma-product-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('selouma-product-bundle')) {
  customElements.define('selouma-product-bundle', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else this.init();
    }
    init() {
      this.form = document.getElementById(this.dataset.formId);
      this.nativeButtons = this.closest('.product-info__block-list')?.querySelector('[data-block-type="buy-buttons"]');
      this.first = { id: Number(this.dataset.variantId), price: Number(this.dataset.variantPrice), compare: Number(this.dataset.variantComparePrice), title: this.dataset.productTitle };
      this.second = null;
      this.mode = 'two';
      this.dialog = this.querySelector('[data-dialog]');
      this.one = this.querySelector('[data-choice="one"]');
      this.two = this.querySelector('[data-choice="two"]');
      this.addButton = this.querySelector('[data-add-two]');
      this.addOneButton = this.querySelector('[data-add-one]');
      this.results = this.querySelector('[data-results]');
      this.initialResults = this.results.innerHTML;
      this.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', () => this.setMode(input.value)));
      this.querySelector('[data-open-picker]').addEventListener('click', () => {
        this.querySelector('[data-search]').value = '';
        this.searchTerm = '';
        this.results.innerHTML = this.initialResults;
        this.dialog.showModal();
      });
      this.querySelector('[data-close-picker]').addEventListener('click', () => this.dialog.close());
      this.results.addEventListener('click', event => {
        const more = event.target.closest('[data-more]');
        if (more) {
          const expanded = more.closest('[data-group]').classList.toggle('is-expanded');
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? this.dataset.seeLessLabel : this.dataset.seeMoreLabel;
          return;
        }
        const button = event.target.closest('[data-choose-product]');
        if (button) this.chooseProduct(button.closest('.selouma-bundle__result'));
      });
      this.results.addEventListener('change', event => {
        if (!event.target.matches('[data-sale-variant]')) return;
        const row = event.target.closest('.selouma-bundle__result');
        const option = event.target.selectedOptions[0];
        row.querySelector('[data-sale-price]').textContent = this.money(Number(option.dataset.price));
        row.querySelector('[data-regular-price]').textContent = this.money(Number(option.dataset.compare));
      });
      let timer;
      this.querySelector('[data-search]').addEventListener('input', event => {
        clearTimeout(timer);
        const term = event.target.value.trim();
        if (term.length < 2) {
          this.searchTerm = '';
          this.results.innerHTML = this.initialResults;
          return;
        }
        this.searchTerm = term;
        timer = setTimeout(() => this.search(term), 220);
      });
      this.addButton.addEventListener('click', () => this.addTwo());
      this.addOneButton.addEventListener('click', () => this.addOne());
      document.addEventListener('variant:change', event => {
        if (event.target !== this.form || !event.detail?.variant) return;
        const variant = event.detail.variant;
        this.first = { id: Number(variant.id), price: Number(variant.price), compare: Number(variant.compare_at_price) || Number(variant.price), title: variant.title };
        this.querySelector('[data-first-variant]').textContent = variant.title;
        this.update();
      });
      this.setMode('two');
    }
    money(cents) {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(cents / 100);
    }
    root() { return this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/'; }
    openCart() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        drawer.show();
      } else {
        window.location.assign(this.root() + 'cart');
      }
    }
    setMode(mode) {
      this.mode = mode;
      this.one.classList.toggle('is-selected', mode === 'one');
      this.two.classList.toggle('is-selected', mode === 'two');
      this.querySelector('input[value="one"]').checked = mode === 'one';
      this.querySelector('input[value="two"]').checked = mode === 'two';
      if (this.nativeButtons) {
        this.nativeButtons.hidden = mode === 'two';
        this.nativeButtons.classList.toggle('selouma-bundle-native-hidden', mode === 'two');
      }
      this.addOneButton.hidden = mode !== 'one' || Boolean(this.nativeButtons);
      this.two.querySelector('.selouma-bundle__contents').hidden = mode === 'one';
      this.update();
    }
    update() {
      this.querySelector('[data-one-price]').textContent = this.money(this.first.price);
      this.addOneButton.textContent = this.dataset.addOneLabel.replace('{amount}', this.money(this.first.price));
      const price = this.querySelector('[data-bundle-price]');
      const original = this.querySelector('[data-bundle-original]');
      const saving = this.querySelector('[data-saving]');
      if (!this.second) {
        price.textContent = this.dataset.chooseLabel;
        original.hidden = true;
        saving.textContent = this.dataset.chooseToSaveLabel || saving.textContent;
        saving.hidden = false;
        this.addButton.disabled = true;
        this.addButton.textContent = this.dataset.chooseLabel;
        return;
      }
      const subtotal = this.first.price + this.second.price;
      const regular = Math.max(this.first.compare || 0, this.first.price) + Math.max(this.second.compare || 0, this.second.price);
      price.textContent = this.money(subtotal);
      original.hidden = regular <= subtotal;
      if (!original.hidden) original.textContent = this.money(regular);
      saving.hidden = regular <= subtotal;
      if (!saving.hidden) saving.textContent = this.dataset.savingLabel.replace('{amount}', this.money(regular - subtotal));
      this.addButton.disabled = false;
      this.addButton.textContent = this.dataset.addLabel.replace('{amount}', this.money(subtotal));
    }
    async search(term) {
      const params = new URLSearchParams({ q: term, 'resources[type]': 'product', 'resources[limit]': '10', 'resources[options][unavailable_products]': 'hide' });
      try {
        const response = await fetch(this.root() + 'search/suggest.json?' + params);
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        const products = await Promise.all((data.resources.results.products || [])
          .filter(product => product.handle !== this.dataset.productHandle)
          .map(async product => {
            const detail = await fetch(this.root() + 'products/' + encodeURIComponent(product.handle) + '.js');
            return detail.ok ? detail.json() : null;
          }));
        if (this.searchTerm !== term) return;
        this.results.replaceChildren();
        for (const product of products.filter(Boolean)) {
          const saleVariants = product.variants.filter(variant => variant.available && Number(variant.compare_at_price) > Number(variant.price));
          if (!saleVariants.length) continue;
          const sale = saleVariants[0];
          const row = document.createElement('div');
          row.className = 'selouma-bundle__result'; row.dataset.title = product.title; row.dataset.image = product.featured_image || '';
          if (product.featured_image) {
            const image = document.createElement('img'); image.src = product.featured_image; image.alt = ''; row.append(image);
          }
          const text = document.createElement('span'); text.className = 'selouma-bundle__result-copy';
          const name = document.createElement('strong'); name.textContent = product.title;
          const prices = document.createElement('span'); prices.className = 'selouma-bundle__result-prices';
          const current = document.createElement('span'); current.dataset.salePrice = ''; current.textContent = this.money(sale.price);
          const regular = document.createElement('s'); regular.dataset.regularPrice = ''; regular.textContent = this.money(sale.compare_at_price);
          prices.append(current, regular); text.append(name, prices);
          const selector = document.createElement(saleVariants.length > 1 ? 'select' : 'input');
          selector.dataset.saleVariant = '';
          if (saleVariants.length > 1) {
            selector.setAttribute('aria-label', product.title + ' — ' + this.dataset.variantLabel);
            for (const variant of saleVariants) {
              const option = new Option(variant.title, variant.id);
              option.dataset.price = String(variant.price);
              option.dataset.compare = String(variant.compare_at_price);
              option.dataset.variantTitle = variant.title;
              selector.add(option);
            }
          } else {
            selector.type = 'hidden'; selector.value = String(sale.id);
            selector.dataset.price = String(sale.price); selector.dataset.compare = String(sale.compare_at_price);
            selector.dataset.variantTitle = sale.title;
          }
          text.append(selector); row.append(text);
          const choose = document.createElement('button'); choose.type = 'button'; choose.className = 'selouma-bundle__result-action';
          choose.dataset.chooseProduct = ''; choose.textContent = this.dataset.chooseShortLabel;
          row.append(choose); this.results.append(row);
        }
        if (!this.results.children.length) this.results.textContent = this.dataset.noResultsLabel;
      } catch (error) { if (this.searchTerm === term) this.results.textContent = this.dataset.searchErrorLabel; }
    }
    chooseProduct(card) {
      if (!card) return;
      const selector = card.querySelector('[data-sale-variant]');
      const selected = selector?.tagName === 'SELECT' ? selector.selectedOptions[0] : selector;
      if (!selected) return;
      this.second = { id: Number(selector.value), price: Number(selected.dataset.price), compare: Number(selected.dataset.compare), title: card.dataset.title, variant: selected.dataset.variantTitle, image: card.dataset.image };
      const row = this.querySelector('[data-second-item]'); row.replaceChildren(); row.hidden = false;
      if (this.second.image) {
        const image = document.createElement('img'); image.className = 'selouma-bundle__thumb'; image.src = this.second.image; image.alt = ''; row.append(image);
      }
      const text = document.createElement('div'); const name = document.createElement('strong'); name.textContent = this.second.title;
      const variant = document.createElement('small'); variant.textContent = this.second.variant;
      text.append(name, variant); row.append(text);
      this.querySelector('[data-open-picker]').textContent = this.dataset.changeLabel;
      this.dialog.close(); this.update();
    }
    async addOne() {
      if (!this.first.id || this.addOneButton.disabled) return;
      this.addOneButton.disabled = true;
      const message = this.querySelector('[data-one-error]');
      message.hidden = true;
      try {
        const response = await fetch(this.root() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.first.id, quantity: 1 }] })
        });
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.description || this.dataset.cartErrorLabel);
        }
        this.openCart();
      } catch (error) {
        message.textContent = error.message || this.dataset.cartErrorLabel;
        message.hidden = false;
        this.addOneButton.disabled = false;
      }
    }
    async addTwo() {
      if (!this.second || !this.first.id || this.addButton.disabled) return;
      this.addButton.disabled = true;
      this.querySelector('[data-error]').hidden = true;
      try {
        const response = await fetch(this.root() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.first.id, quantity: 1 }, { id: this.second.id, quantity: 1 }] })
        });
        if (!response.ok) {
          const data = await response.json(); throw new Error(data.description || this.dataset.cartErrorLabel);
        }
        this.openCart();
      } catch (error) {
        const message = this.querySelector('[data-error]'); message.textContent = error.message || this.dataset.cartErrorLabel; message.hidden = false;
        this.addButton.disabled = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
